import React from "react";
import { Select as AntdSelect } from "antd";
import { OptionProps, SelectProps } from "antd/lib/select";
import get from "lodash/get";
import styled from "themes/styled";

interface IProps extends SelectProps<any> {
  data?: any[];
  getDisplayText?: (data: any) => string | React.ReactNode;
  getValue?: (data: any) => string | number;
  renderItem?: (item: any, index: number) => React.ReactNode;
  hasError?: boolean;
  optionProps?: Partial<OptionProps>;
}

const Select = (props: IProps) => {
  const {
    data = [],
    getDisplayText = defaultGetDisplayText,
    getValue = defaultGetValue,
    optionProps = {},

    renderItem = (cb: any, index: number) => {
      const value = getValue(cb);
      const key = value || index;
      return (
        <AntdSelect.Option value={value} key={key} {...optionProps}>
          {getDisplayText(cb)}
        </AntdSelect.Option>
      );
    },
    ...rest
  } = props;

  return <StyledSelect {...rest}>{data.map(renderItem)}</StyledSelect>;
};

const defaultGetDisplayText = (data: any) => get(data, "name");

const defaultGetValue = (data: any) => get(data, "value");

interface StyledSelectProps extends SelectProps<any> {
  hasError?: boolean;
}

const StyledSelect = styled(AntdSelect)`
  & > div {
    border-color: ${(props: any) =>
      props.hasError && props.theme.danger_color} !important;
    &:focus {
      border-color: ${(props: any) =>
        props.hasError && props.theme.danger_color} !important;
      box-shadow: ${(props: StyledSelectProps) =>
        props.hasError && "0 0 0 2px rgba(255, 0, 0, 0.2) !important"};
    }
  }
`;

export default Select;
